<template>
    <div class="page-content">
        <app-title text="Módulo de Administración" />
        <router-view></router-view>
    </div>
</template>
<script>
    import Title from '../../UI/Layout/Title.vue';
    export default {
        components: {
            appTitle: Title
        },
        name: 'admin-page'
    }
</script>